import Vue from 'vue';
import VueI18n from 'vue-i18n';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale';
import { getCookie } from '@/utils/index.js';

Vue.use(VueI18n);

// import zh from './config/zh';
// import en from './config/en';

const i18n = new VueI18n({
  // locale: localStorage.getItem('locale') || 'zh',
  locale: getCookie('locale') || 'zh_cn',
  messages: {
    zh_cn: {
      ...mlanguage_zh_cn,
      ...elementZhLocale
    },
    en_us: {
      ...mlanguage_en_us,
      ...elementEnLocale
    }
  }
})

locale.i18n((key, value) => i18n.t(key, value));

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n/index.js